<div class="text-center" style="padding:3rem 0;">
	<img [src]="imgSrc" style="padding:1rem; max-width:100%">
	<br>
	<h5 [innerHTML]="title"></h5>
	<p>{{description}}</p>
	<div #content><ng-content></ng-content><div>
</div>
